export class GeneralUserVerificationError extends Error {
  constructor() {
    super('General user verification error');
  }

}